export default __webpack_public_path__ + "static/media/IC00066-continuous.f0746afa.svg";